<template>
  <div class="row">
    <Form @submit="submitForm" v-slot="{ errors }">
      <div class="card text-start p-3 m-2">
        <p class="fw-bold">User Setup</p>
        <hr />
        <div class="mb-3 row">
          <label class="col-sm-2 col-form-label">User Name</label>
          <div class="col-sm-10">
            <Field type="text" class="form-control" v-model="username" name="username" rules="required"
              :class="errors.username ?'is-invalid':'' " />

            <ErrorMessage name="username" style="color:red" />

          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-sm-2 col-form-label">User Email</label>
          <div class="col-sm-10">
            <Field type="email" class="form-control" v-model="email" name="email" rules="required|email"
              :class="errors.email ?'is-invalid':'' " />
            <ErrorMessage name="email" style="color:red" />
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-sm-2 col-form-label">Password</label>
          <div class="col-sm-10">
            <Field type="password" class="form-control" v-model="password" name="password" rules="required"
              :class="errors.password ?'is-invalid':'' " />
            <ErrorMessage name="password" style="color:red" />

          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-sm-2 col-form-label">Created Date</label>
          <div class="col-sm-10">
            <Field type="text" disabled class="form-control" v-model="createdDate" name="createdDate" />
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-sm-2 col-form-label">Status</label>
          <div class="col-sm-10">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="userStatus"
                name="userStatus" checked value="active" />
              <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
            </div>
          </div>
        </div>
      </div>
      <button>submit</button>
    </Form>
  </div>
</template>

<script>
  import {
    Field,
    Form,
    ErrorMessage
  } from 'vee-validate';
  export default {
    components: {
      Field,
      Form,
      ErrorMessage,
    },
    created(){
        const listRoute = this.$route.path.split("/");
        this.id = listRoute[listRoute.length-1]
        console.log(this.id) 
    },
    data() {
      return {
        id : "",
        username: "",
        email: "",
        password: "",
        userStatus: "",
        configSelect: {
          multiple: false,
          placeholder: "-Select-",
          readonly: true,
          required: true,
          name: "select_example",
          uid: "select_example1", //select using dp-input-${uid}
          autocomplete: "off", //prevent cache on input to show
        },

      }
    },
    methods: {
      
      async getData() {
        const payload = {
          size : 1,
          id : this.id
        }
        console.log(payload)
        const response = await this.axios.get("https://dev-admin-api.paxelmarket.co/api/v1/buyer", {
          params: payload
        })

        console.log(response)
      }
    },
    mounted() {
      this.getData()
    },
  }
</script>

<style>
  .error-border {
    border: 1px red solid !important;
  }
</style>